"use client";

import { useContext } from 'react';
import { ModalContext } from '@/context/ModalContext';
import { IModalActions, ModalTypes } from '@/types/modal';
import styles from './StateHeader.module.scss';

const IconBrochureArrow = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M11.5093 0.0761023C11.3004 0.158071 10.9434 0.496431 10.8045 0.744073C10.706 0.919462 10.6931 1.53004 10.6636 7.41966L10.6311 13.9022L8.38666 11.6755C6.91582 10.2164 6.05253 9.40724 5.88202 9.32816C5.41505 9.11166 4.82038 9.21962 4.42712 9.59234C4.21088 9.79733 4.0308 10.2204 4.0308 10.5237C4.0308 11.0857 4.11453 11.1818 7.69044 14.7262C9.55825 16.5775 11.2036 18.1594 11.3467 18.2415C11.7089 18.4494 12.0092 18.4878 12.3905 18.3754C12.6899 18.2872 12.9687 18.0267 16.2995 14.7237C19.7835 11.2689 19.8884 11.1577 19.9627 10.8405C20.1558 10.016 19.5179 9.20701 18.673 9.20508C18.1497 9.20386 18.0755 9.26382 15.6566 11.6425L13.3309 13.9296V7.4795C13.3309 0.491027 13.345 0.781326 12.9862 0.400887C12.6525 0.0470211 11.9675 -0.103597 11.5093 0.0761023ZM0.840673 17.2209C0.542393 17.3488 0.338379 17.5426 0.169364 17.8583C0.0451733 18.0903 0.0291042 18.2437 0.00646486 19.4132C-0.0351707 21.5602 0.115303 22.371 0.721556 23.2675C1.23309 24.0238 2.03978 24.6073 2.95452 24.8825C3.32404 24.9938 3.80623 25 11.9972 25H20.6496L21.1376 24.8505C21.8205 24.6413 22.4098 24.2779 22.8986 23.7644C23.3982 23.2397 23.6973 22.7078 23.8715 22.0342C23.9837 21.6003 24 21.3195 24 19.8205C24 18.1475 23.9962 18.0965 23.8486 17.8202C23.4201 17.0175 22.3198 16.8884 21.699 17.568C21.5739 17.705 21.4405 17.9277 21.4025 18.0629C21.3631 18.2031 21.3327 18.9581 21.3317 19.8207C21.3301 21.1434 21.315 21.365 21.2114 21.5906C21.0624 21.9149 20.6947 22.2382 20.3749 22.3261C20.0144 22.4251 3.93068 22.4203 3.63104 22.321C3.29639 22.2102 3.00214 21.9667 2.84061 21.6667C2.70367 21.4125 2.69346 21.2991 2.66229 19.692C2.62684 17.863 2.61272 17.7845 2.26045 17.4593C1.90615 17.1321 1.28923 17.0285 0.840673 17.2209Z" fill="white"/>
  </svg>
);
const MBA_BROCHURE_URL = "https://static.amityonline.com/_s/MBA_29009413ae.pdf";

export default function StateHeaderBrochureBtn({ associatedPrograms }: { associatedPrograms?: any }) {
  const { modalDispatch } = useContext(ModalContext);

  const handleClick = () => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ConnectModalMba,
        modalData: {
          rfiCase: "DOWNLOAD_BROCHURE_CASE",
          attachmentURL: MBA_BROCHURE_URL,
          associatedPrograms,
          modalVariant: "downloadBrochure",
        },
      },
    });
  };

  return (
    <button className={styles.brochureBtn} onClick={handleClick}>
      Download Brochure
      <IconBrochureArrow />
    </button>
  );
}
